export default __webpack_public_path__ + "static/media/cob3.2fca2876.png";